import { create } from 'zustand';

interface Event {
  id: string;
  title: string;
  titleEn?: string;
  status: string;
  eventDate?: string;
  registrationDeadline?: string;
  modules?: any[];
  moduleCount?: number;
  bookingCount?: number;
  confirmedCount?: number;
  theme?: any;
}

interface Registration {
  id: string;
  eventId: string;
  status: string;
  formData: any;
  createdAt: string;
}

interface AdminStore {
  // Events
  events: Event[];
  currentEvent: Event | null;
  setEvents: (events: Event[]) => void;
  setCurrentEvent: (event: Event | null) => void;

  // Registrations
  registrations: Registration[];
  setRegistrations: (registrations: Registration[]) => void;

  // UI State
  sidebarOpen: boolean;
  toggleSidebar: () => void;

  // Stats
  stats: {
    activeEvents: number;
    totalRegistrations: number;
    pendingPayments: number;
    totalRevenue: number;
  };
  setStats: (stats: any) => void;
}

export const useAdminStore = create<AdminStore>((set) => ({
  events: [],
  currentEvent: null,
  setEvents: (events) => set({ events }),
  setCurrentEvent: (event) => set({ currentEvent: event }),

  registrations: [],
  setRegistrations: (registrations) => set({ registrations }),

  sidebarOpen: true,
  toggleSidebar: () => set((state) => ({ sidebarOpen: !state.sidebarOpen })),

  stats: {
    activeEvents: 0,
    totalRegistrations: 0,
    pendingPayments: 0,
    totalRevenue: 0,
  },
  setStats: (stats) => set({ stats }),
}));
